
import BasePageView from "components/core/BasePageView/BasePageView";
import useDDPoDetailsLogic from "./useDDPoDetailsLogic";
import DDPoDetailsMobile from "./DDPoDetailsMobile";
import DDPoDetailsDesktop from "./DDPoDetailsDesktop";

const DDPoDetails = () => {
  const vm = useDDPoDetailsLogic();
  return (
    <BasePageView
      DesktopView={DDPoDetailsDesktop}
      MobileView={DDPoDetailsMobile}
      viewProps={vm}
    />
  );
};

export default DDPoDetails;
